import { useState } from 'react';
import { nudosGray850 } from '../../../../styles/styles.constants';
import BordOneToneIcon from '../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import NudosButton from '../../../NudosComponents/NudosButton/NudosButton';
import './CommentImage.scss';

const CommentImage = ({
  imageUrl,
  displayDownloadButton = true
}: {
  imageUrl?: string;
  displayDownloadButton?: boolean;
}) => {
  const [showImageModal, setShowImageModal] = useState(false);

  const handleDownloadImage = () => {
    if (!imageUrl) return;
    window.open(imageUrl, '_blank');
  };

  if (!imageUrl) return null;

  return (
    <div className="commentImage">
      <div className="imagePreviewContainer">
        <div className="imagePreviewWrapper" onClick={() => setShowImageModal(true)}>
          <img src={imageUrl} alt="Imagen adjunta al comentario" className="previewImage" />
        </div>

        {displayDownloadButton && (
          <div className="downloadButton" onClick={handleDownloadImage}>
            <div>Descargar</div>
            <BordOneToneIcon variant="download" className="downloadButtonIcon" stroke={nudosGray850} />
          </div>
        )}
      </div>

      {showImageModal && (
        <div className="imageModalOverlay" onClick={() => setShowImageModal(false)}>
          <div className="imageModalContent">
            <img src={imageUrl} alt="Vista ampliada de la imagen" className="fullsizeImage" />

            <div className="modalActionButtons">
              <NudosButton
                buttonText="Cerrar"
                handleClick={() => setShowImageModal(false)}
                customWidth="180px"
                customHeight="40px"
                colorPalette="secondary"
              />
              <NudosButton
                buttonText="Descargar imagen"
                handleClick={handleDownloadImage}
                customWidth="180px"
                customHeight="40px"
                customClassName="darkButton"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentImage;
